module.exports = __webpack_public_path__ + "static/media/q2.5a761aff.svg";